import OrdersGridCard from "./OrdersGridCard";

export default function OrdersGrid({
  rows,
  cancelingOrderId,
  onEdit,
  onCancel,
}) {
  return (
    <div className="w-full min-h-0 flex-1 flex flex-col gap-4 overflow-y-auto mb:hidden">
      {rows.map((row) => (
        <OrdersGridCard
          key={row.id}
          {...row}
          isCanceling={cancelingOrderId === String(row.id)}
          onEdit={() => onEdit(row)}
          onCancel={onCancel}
        />
      ))}
    </div>
  );
}
